import { useState } from "react";
import { InstagramLogo, EnvelopeSimple, SpinnerGap, Check } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function Contacto() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Por favor, completa todos los campos.");
      return;
    }
    setStatus("loading");
    try {
      await api.post("/contact", form);
      setStatus("done");
      toast.success("¡Mensaje enviado! Te responderé muy pronto.");
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => setStatus("idle"), 3000);
    } catch {
      setStatus("idle");
      toast.error("No se pudo enviar el mensaje. Inténtalo de nuevo.");
    }
  };

  const input =
    "w-full bg-white border border-[#EBEBEB] rounded-2xl px-5 py-4 text-[#2D3732] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#A3B18A] focus:border-[#A3B18A] transition-all";

  return (
    <section id="contacto" data-testid="contacto-section" className="py-24 md:py-36 bg-[#F6F1E7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16">
        <Reveal>
          <p className="overline mb-6">
            <span className="text-[#8A9A6F]">11</span> &nbsp;/&nbsp; Contacto
          </p>
          <h2 className="font-display text-4xl md:text-5xl text-[#2D3732] leading-tight">
            Hablemos de tu tranquilidad.
          </h2>
          <p className="text-[#4A554E] mt-6 max-w-md leading-relaxed font-light">
            ¿Tienes dudas o quieres una recomendación personalizada? Escríbeme y te acompaño en tu
            camino hacia una salud más organizada.
          </p>

          <div className="mt-10 space-y-4">
            <a
              href="mailto:vitaebyana@gmail.com"
              data-testid="contact-email"
              className="flex items-center gap-4 text-[#2D3732] hover:text-[#8A9A6F] transition-colors group"
            >
              <span className="w-12 h-12 rounded-full bg-white flex items-center justify-center border border-[#EBEBEB] group-hover:border-[#A3B18A] transition-colors">
                <EnvelopeSimple size={22} weight="light" />
              </span>
              vitaebyana@gmail.com
            </a>
            <a
              href="https://instagram.com/vitaebyana"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram"
              className="flex items-center gap-4 text-[#2D3732] hover:text-[#8A9A6F] transition-colors group"
            >
              <span className="w-12 h-12 rounded-full bg-white flex items-center justify-center border border-[#EBEBEB] group-hover:border-[#A3B18A] transition-colors">
                <InstagramLogo size={22} weight="light" />
              </span>
              @vitaebyana
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <form onSubmit={submit} data-testid="contact-form" className="space-y-4">
            <input
              data-testid="contact-name"
              className={input}
              placeholder="Tu nombre"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
            <input
              data-testid="contact-email-input"
              type="email"
              className={input}
              placeholder="Tu correo electrónico"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
            <textarea
              data-testid="contact-message"
              className={`${input} min-h-[160px] resize-none`}
              placeholder="¿En qué puedo ayudarte?"
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
            />
            <button
              type="submit"
              data-testid="contact-submit"
              disabled={status === "loading"}
              className="w-full bg-[#A3B18A] hover:bg-[#8A9A6F] text-white rounded-full py-4 text-sm tracking-wide transition-colors duration-300 flex items-center justify-center gap-2 disabled:opacity-60"
            >
              {status === "loading" && <SpinnerGap size={18} className="animate-spin" />}
              {status === "done" && <Check size={18} />}
              {status === "loading" ? "Enviando…" : status === "done" ? "Enviado" : "Enviar mensaje"}
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
